/** @format */

import React, {createContext} from 'react';

const proofingDefaultState = {
    openApproveAllModal: false,
    lastDesignToReviewId: null,
    currentReviewedCount: 0,
    formData: {
        disapproveReason: '',
        reasonId: null
    },
    showSubmitModal: null,
    specsVerification: {
        isVerified: false,
        verifiedOn: null,
        verifiedBy: '',
        orderId: null
    },
    reviewNotesVerification: {
        isVerified: false,
        verifiedOn: null,
        verifiedBy: '',
        orderId: null
    },
    selectedDesigns: [],
    isSubmitting: false,
    designsOrders: [],
    currentProof: {designs_alerts: []},
    shareLink: false, // For linking to the full order pdf
    shareKey: false, // For linking to a single design pdf
    complete: null,
    loading: true,
    error: false,
    order: {}
};

const proofingDefaultContext = {
    data: proofingDefaultState,
    handleDesignDisapproveReasonId: () => {},
    handleDesignDisapproveReason: () => {},
    handleUndoDesignReview: () => {},
    handleReplaceDesign: () => {},
    handleApproveSpecs: () => {},
    handleApproveNotes: () => {},
    onApproveSelected: () => {},
    handleDesignReview: () => {},
    handleApproveAll: () => {},
    handleRejectAll: () => {},
    handleCollapse: () => {},
    handleChange: () => {},
    onCheck: () => {}
};

const ProofingContext = createContext(proofingDefaultContext);

export {ProofingContext, proofingDefaultState};
